module.exports = __webpack_public_path__ + "img/190.ab51521d.jpg";